import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InputSelect from '../../Forms/InputSelect.jsx';
import Positions from '../../Forms/Data/Positions.js';
import nationalities from '../../Forms/Data/nationalities.js';
import InputText from '../../Forms/InputText.jsx';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import AxiosClient from '../../assets/AxiosClient.js';
import SliderRow from './SliderRow.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Slides = () => {
  const { SetNotification } = useStateContext();
  const [Slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [SlidesPerPage, setSlidesPerPage] = useState(7);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/slides');
        const res  = await response.data;
        setSlides(res);
        console.log(res) ; 
        setLoading(true);
      } catch (error) {
        SetNotification('Error fetching data:', 'danger');
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
  if (!loading ) {
    return (<h1>Loading </h1> );
  }
  if (Slides.length ==0 ) {
    return ( <h1 > no Slier found</h1> );
  }

  const indexOfLastPaper = currentPage * SlidesPerPage;
  const indexOfFirstPaper = indexOfLastPaper - SlidesPerPage;
  const currentSlides = Slides.slice(indexOfFirstPaper, indexOfLastPaper);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className='card-body px-0 pb-2'>
        <div className='p-0 border'>
          <table className='border table  text-center justify-content-center mb-0 text-dark'>
            <thead>
              <tr className='ro2'>
                <th className='col-2'>Title </th>
               
              </tr>
            </thead>
            <tbody>
              {loading ? (
                currentSlides.map((Slide) => (
                  <SliderRow key={Slide.id} slider={Slide} />
                ))
              ) : (
                <tr>
                  <td colSpan='3'><Loader label="Loading slides..." /></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className='pagination m-2 p-2 '>
          {Slides.length > SlidesPerPage && (
            <ul className='pagination m-2 '>
              {Array(Math.ceil(Slides.length / SlidesPerPage))
                .fill()
                .map((_, index) => (
                  <li key={index} className='page-item'>
                    <button className='page-link' onClick={() => paginate(index + 1)}>
                      {index + 1}
                    </button>
                  </li>
                ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default Slides;